import React, { PropTypes } from "react";
import { FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toast } from "react-toastify";
import { EN } from "../../../common/enums/languages";
import enCA from "../../../intl/en-CA";
import frCA from "../../../intl/fr-CA";
import {
  Field,
  change as changeFieldValue,
  untouch,
  formValueSelector,
  reduxForm,
} from "redux-form";
import MessageBox from "../../../common/MessageBox";
import copyIcon from "../../../../assets/images/content_copy.svg";
import pasteIcon from "../../../../assets/images/file_copy.svg";

import { FileInput, SelectInput } from "../../../common/form";

import { MANUAL } from "../../clients/enums/billingPeriodTypes";
import FORMATS, { AETELUQ, AGECRO_CONTINUING_EDUCATION, AGECRO_ONLINE_EDUCATION, AGECRO_REGULAR_EDUCATION, CORPORATE, FEUS } from "./enums/importMemberFormats";
import { PM } from "../../clients/enums/businessAccountTypes";

import validationUtils from "../../../../utils/ValidationUtils";
import IMPORT_ERRORS from "./enums/importMemberErrors";
import { IMPORT_MEMBERS_VALIDATION_RULES } from "./importMembersValidationRules";
import { LAST_ACTIVE_DATE_ERROR, RETROACTIVE_LIMIT_ERROR } from "../../../common/enums/apiHooksErrorType";

class ImportMembersForm extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidUpdate(prevProps) {
    const { classes, fileFormat, selectedClient, billingPeriodId } = this.props;
    if (classes && prevProps.classes != classes && classes.length === 1) {
      if (selectedClient && selectedClient.businessAccountType == PM.value && selectedClient.clientBillingPeriodType == MANUAL.value) {
        this.props.changeFieldValue("importMembersForm", "classId", classes[0].classId);
      }
    }

    if (selectedClient && !prevProps.fileFormat) {
      if (this.translationFromKey(AGECRO_REGULAR_EDUCATION.key, frCA).includes(selectedClient.name)) {
        this.props.changeFieldValue("importMembersForm", "fileFormat", AGECRO_REGULAR_EDUCATION.value);
      }

      if (this.translationFromKey(AGECRO_ONLINE_EDUCATION.key, frCA).includes(selectedClient.name)) {
        this.props.changeFieldValue("importMembersForm", "fileFormat", AGECRO_ONLINE_EDUCATION.value);
      }

      if (this.translationFromKey(AGECRO_CONTINUING_EDUCATION.key, frCA).includes(selectedClient.name)) {
        this.props.changeFieldValue("importMembersForm", "fileFormat", AGECRO_CONTINUING_EDUCATION.value);
      }
    }

    if (fileFormat) {
      if (fileFormat !== AGECRO_REGULAR_EDUCATION.value) {
        this.props.changeFieldValue("importMembersForm", "importSessionPeriod", "");
        this.props.resetErrorField('importMembersForm', 'importSessionPeriod');
      } else {
        if (billingPeriodId) {
          const billingPeriod = this.props.billingPeriods.find((item) => item.billingPeriodId.toString() === billingPeriodId.toString());
          const billingPeriodLitteral = billingPeriod.localizations[this.userLanguage].name;
          const session = this.props.sessions.find((item) => billingPeriodLitteral.includes(this.translationFromKey(item.key)));
          if (session) {
            if (prevProps.importSessionPeriod === undefined || prevProps.billingPeriodId !== billingPeriodId) {
              this.props.changeFieldValue("importMembersForm", "importSessionPeriod", session.value);
            }
          }
        }
      }
    }
  }

  userLanguage = localStorage.getItem("languageCode") || EN.value;
  translationFile = this.userLanguage == EN.value ? enCA : frCA;

  translationFromKey(key, translationFile = this.translationFile) {
    return key.split('.').reduce((acc, key) => acc && acc[key], translationFile);
  }

  handleClientChange(event) {
    this.props.reset("importMembersForm");
    this.props.handleClientChange(event);
  }

  getMessageFromValues(values) {
    const errorEnum = IMPORT_ERRORS.find((code) => code.value === values.code);

    if (errorEnum !== undefined) {
      // It's not a data value error
      return <FormattedMessage id={errorEnum.key} values={{ ...values }} />;
    }

    let errors = [];

    for (const [key, value] of Object.entries(values)) {
      // We just want to display pertinent data to user
      if (key === "code" || key === "key") {
        continue;
      }

      const keyId = "importExport.importMembers.errors." + key;
      let returnedValue = "";

      if (Array.isArray(value)) {
        value.forEach((v) => (returnedValue += v + ", "));
        returnedValue = returnedValue.slice(0, -2);
      } else {
        returnedValue = value;
      }

      errors.push(
        <ul key={keyId}>
          -
          <FormattedMessage
            id={keyId}
            values={{ numberOfValues: Array.isArray(value) ? value.length : 1 }}
          />
          <span>: {returnedValue}</span>
        </ul>
      );
    }
    return errors;
  }

  copyTable(tableId, event) {
    event.preventDefault();
    event.stopPropagation();
    try {
      const table = document.getElementById(tableId);
      let tsvData = Array.from(table.querySelectorAll('tr'))
        .map(row => Array.from(row.querySelectorAll('td, th'))
          .map(cell => cell.innerText.trim())
          .join('\t'))
        .join('\n');

      let tempElement = document.createElement('textarea');
      tempElement.value = tsvData;
      document.body.appendChild(tempElement);
      tempElement.select();
      document.execCommand('copy');
      document.body.removeChild(tempElement);
      const imgElement = event.currentTarget.querySelector('img');
      if (imgElement) {
        imgElement.src = pasteIcon;
        setTimeout(() => {
          imgElement.src = copyIcon;
        }, 2000);
      }
    } catch (err) {
      toast(err, {
        type: toast.TYPE.ERROR,
        autoClose: true,
      });
    }
  }


  displayHistoricalMessages(response) {
    // Previous way to deal with error messages returned by API
    const isError = Object.keys(response)[0] === "error";
    let message = [];

    if (Object.keys(response).length > 0) {
      const data = isError ? response["error"].data : response.data;
      const className = isError ? "alert-danger" : "alert-success";
      let messageContent;

      if (isError && data) {
        let messageErrors = data.message;
        let messageErrorsContent;

        if (Array.isArray(messageErrors)) {
          messageErrorsContent = messageErrors.map((error, index) => {
            if (Array.isArray(error)) {
              return error.map((e, i) => <p key={`error-${index}-${i}`}>{JSON.stringify(e)}</p>);
            } else {
              return <p key={`error-${index}`}>{JSON.stringify(error)}</p>;
            }
          });
        } else {
          switch (data.error) {
            case "import_column_error": {
              messageErrorsContent = <span><FormattedMessage id="importErrors.columnError" values={{ fileNum: messageErrors.got, expectedNum: messageErrors.expecting, br: <br /> }} /></span>;
              break;
            }
            case "unauthorized_country_error": {
              messageErrorsContent = <span><FormattedMessage id="importErrors.unauthorizedCountryCode" values={{ country: messageErrors.country }} /></span>;
              break;
            }
            case "import_data_type_error": {
              const errorValue = messageErrors.includes(":") && messageErrors.split(": ")[1];
              if (errorValue) {
                messageErrorsContent = <span><FormattedMessage id="importErrors.dataTypeErrorWithValue" values={{ value: errorValue }} /></span>;
              }
              else {
                messageErrorsContent = <span><FormattedMessage id="importErrors.dataTypeError" /></span>;
              }
              break;
            }
            case "import_agecro_api_error": {
              const key = data.message.split("-")[1].trim();
              messageErrorsContent = <p key={key}> <FormattedMessage id={key} /> </p>;
              break;
            }
            case "import_data_error_division": {
              const errorValue = messageErrors.includes(":") && messageErrors.split(": ")[1];
              messageErrorsContent = <span><FormattedMessage id="importErrors.dataTypeErrorDivision" values={{ value: errorValue }} /></span>;
              break;
            }
            case "import_data_error_class": {
              const errorValue = messageErrors.includes(":") && messageErrors.split(": ")[1];
              messageErrorsContent = <span><FormattedMessage id="importErrors.dataTypeErrorClass" values={{ value: errorValue }} /></span>;
              break;
            }
            case "import_data_error_coverage": {
              const errorValue = messageErrors.includes(":") && messageErrors.split(": ")[1];
              messageErrorsContent = <span><FormattedMessage id="importErrors.dataTypeErrorCoverage" values={{ value: errorValue }} /></span>;
              break;
            }
            case "import_data_exceeding_length_error": {
              messageErrorsContent = <span><FormattedMessage id="importErrors.dataTypeLengthError" values={{ value: messageErrors.value, length: messageErrors.length }} /></span>;
              break;
            }
            case "import_value_required_error": {
              messageErrorsContent = <span><FormattedMessage id="importErrors.valueRequiredError" values={{ sheet: messageErrors.sheet, row: messageErrors.row, column: messageErrors.column }} /></span>;
              break;
            }
            default:
              messageErrorsContent = <p>{messageErrors}</p>;
          }
        }
        const scrollable =
          Array.isArray(messageErrors) && messageErrors.length > 7
            ? "scrollable"
            : "";
        if (typeof messageErrors === "string" && messageErrors.indexOf(LAST_ACTIVE_DATE_ERROR.value) > -1) {
          const values = this.props.selectedClient.lastActiveDate ? { lastActiveDate: this.props.selectedClient.lastActiveDate } : {};

          messageContent = (
            <div className={scrollable}>
              <p>
                <FormattedMessage id={`importExport.importMembers.errors.${LAST_ACTIVE_DATE_ERROR.value}`} values={values} />
              </p>
            </div>
          );
        }

        else if (typeof messageErrors === "string" && messageErrors.indexOf(RETROACTIVE_LIMIT_ERROR.value) > -1) {
          messageContent = (
            <div className={scrollable}>
              <p>
                <FormattedMessage id={RETROACTIVE_LIMIT_ERROR.value} />
              </p>
            </div>
          );
        }
        else {
          messageContent = (
            <div className={scrollable}>
              <p>
                <FormattedMessage id="importExport.importMembers.messages.error" />
              </p>
              {messageErrorsContent}
            </div>
          );
        }
      } else {
        const memberKeys = ["firstName", "lastName", "memberIdentifier", "invoicedAmount", "statusFees", "session"];
        messageContent = (
          <div>
            <p>
              <FormattedMessage id="importExport.importMembers.messages.success" />
            </p>
            {data && (
              <p>
                <FormattedMessage
                  id="importExport.importMembers.messages.successDetails"
                  values={{
                    received: data.received,
                    inserted: data.inserted,
                    updated: data.updated,
                  }}
                />
              </p>
            )}
            {data.info && data.info.existingMembers && data.info.existingMembers.length > 0 && (
              <p>
                <FormattedMessage
                  id="importExport.importMembers.messages.existingMembers"
                  values={{
                    numberExistingMembers: data.info.existingMembers.length,
                    existingMembers: (
                      <div>
                        <div>
                          <table id="membersInformationsTable" border="3" cellSpacing="3" cellPadding="3" style={{ textAlignLast: 'center', width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                              <tr>
                                {memberKeys.map((key, index) => (
                                  <th key={index}><FormattedMessage id={`importExport.agecro.memberInformationsTable.${key}`} /></th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {data.info.existingMembers.map((member, index) => (
                                <tr key={index}>
                                  {memberKeys.map((key, subIndex) => (
                                    <td key={subIndex}>{member[key]}</td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <button
                          className="copy-button"
                          onClick={(event) => this.copyTable('membersInformationsTable', event)}>
                          <img src={copyIcon} width="20px" />
                        </button>
                      </div>
                    )
                  }}
                />
              </p>
            )}
          </div>
        );
      }

      message = <MessageBox className={className}>{messageContent}</MessageBox>;
    }
    return message;
  }

  displayErrorMessages(data) {
    const className = "alert-danger";
    let scrollableAtSize = 8;
    let errors = [];
    let messageContent;
    const members = data.members;

    members.forEach((member) => {
      for (const [, v] of Object.entries(member)) {
        if (v.code === "ValueError") {
          scrollableAtSize = 3;
          break;
        }
      }
    });

    const scrollable = members.length >= scrollableAtSize ? "scrollable" : "";

    for (const member of members) {
      for (const [member_identifier, values] of Object.entries(member)) {
        const keyId = "importExport.importMembers.errors.key." + values.key;

        errors.push(
          <div key={member_identifier + values.key}>
            <FormattedMessage
              id="importExport.importMembers.errors.message"
              values={{
                member_identifier: member_identifier,
                key: <FormattedMessage id={keyId} />,
              }}
            />
            {this.getMessageFromValues(values)}
          </div>
        );
      }
    }
    messageContent = (
      <div className={scrollable}>
        <p>
          <FormattedMessage id="importExport.importMembers.messages.error" />
        </p>
        <br />
        {errors}
      </div>
    );

    return <MessageBox className={className}>{messageContent}</MessageBox>;
  }

  getFormattedMessage(data, key, messageIdKey = null, values) {
    const messageId =
      messageIdKey ?
        `importExport.importMembers.messages.${messageIdKey}` :
        `importExport.importMembers.messages.${key}`;

    const msg = data[key] > 0 ? (
      <p>
        <FormattedMessage
          id={messageId}
          values={values}
        />
      </p>
    ) : ("");

    return msg;
  }
  getNumberOfMembers(data) {
    const received = this.getFormattedMessage(data, "received", null, {
      numberOfReceived: data.received,
      received: data.received,
    });
    const inserted = this.getFormattedMessage(data, "inserted", "imported", {
      numberOfImported: data.inserted,
      imported: data.inserted,
    });
    const updated = this.getFormattedMessage(data, "updated", null, {
      numberOfUpdated: data.updated,
      updated: data.updated,
    });
    const transferred = this.getFormattedMessage(data, "transferred", null, {
      numberOfTransferred: data.transferred,
      transferred: data.transferred,
    });
    const renewed = this.getFormattedMessage(data, "renewed", null, {
      numberOfRenewed: data.renewed,
      renewed: data.renewed,
    });

    return (
      <div>
        {received}
        {inserted}
        {updated}
        {transferred}
        {renewed}
      </div>
    );
  }

  displayMessages(data) {
    const status = data["status"];
    const className = "alert-" + status;
    const keyId = "importExport.importMembers.messages." + status;

    const messageContent = (
      <div>
        <p>
          <FormattedMessage id={keyId} />
        </p>
        <br />
        {this.getNumberOfMembers(data)}
        {data.warning && (
          Object.keys(data.warning).map(key => {
            const messageKey = `importExport.importMembers.messages.${key}`;

            return (
              <p key={key}>
                <FormattedMessage
                  id={messageKey}
                  values={{ nonImportedMembersList: data.warning[key].join(", "), br: <br /> }}
                />
              </p>);
          })
        )
        }

      </div>
    );

    return <MessageBox className={className}>{messageContent}</MessageBox>;
  }

  filterImportMemberFormats() {
    const { selectedClient } = this.props;

    if (!selectedClient) {
      return [];
    } else if (
      selectedClient.clientBillingPeriodType === MANUAL.value &&
      selectedClient.designator !== FEUS.value
    ) {
      return FORMATS.filter(
        (type) => type.value !== CORPORATE.value && type.value !== FEUS.value
      );
    } else if (selectedClient.designator === FEUS.value) {
      return FORMATS.filter((type) => type.value == FEUS.value);
    } else {
      return FORMATS.filter((type) => type.value === CORPORATE.value);
    }
  }

  renderResponse() {
    const { response } = this.props;

    // In case of server error encountered
    if (response.error) {
      return this.displayHistoricalMessages(response);
    }

    // When first coming on the page
    if (!response.data) {
      return;
    }

    switch (response.data["status"]) {
      case "error":
        return this.displayErrorMessages(response.data);
      case "warning":
      case "success":
        return this.displayMessages(response.data);
      case undefined:
        return this.displayHistoricalMessages(response);
      default:
        break;
    }
  }

  renderWarnings() {
    const { allLoaded, noClasses, noCoverages, noDivisions, noClientNumber, selectedClient, clientInTransition } = this.props;
    let warnings = [];

    const isAutomaticMemberIdentifier =
      selectedClient && selectedClient.isAutomaticMemberIdentifier;

    if (allLoaded) {
      if (clientInTransition) {
        warnings.push(
          <MessageBox key="clientInTransitionWarning" className="transition-alert">
            <span className="d-flex">
              <FormattedMessage id="importExport.importMembers.form.warnings.clientInTransition" />
              <button
                className="refresh-transition"
                type="button"
                onClick={() => this.props.refetchIsTransition()}
              >
                <span className="icon icon-loop" />
              </button>
            </span>
          </MessageBox>
        );
      }
      if (noClientNumber) {
        warnings.push(
          <MessageBox key="clientNumberWarning" className="alert-warning">
            <FormattedMessage id="importExport.importMembers.form.warnings.noClientNumber" />
          </MessageBox>
        );
      }
      if (noClasses) {
        warnings.push(
          <MessageBox key="classWarning" className="alert-warning">
            <FormattedMessage id="importExport.importMembers.form.warnings.noClasses" />
          </MessageBox>
        );
      }
      if (noCoverages) {
        warnings.push(
          <MessageBox key="coverageWarning" className="alert-warning">
            <FormattedMessage id="importExport.importMembers.form.warnings.noCoverages" />
          </MessageBox>
        );
      }
      if (noDivisions) {
        warnings.push(
          <MessageBox key="divisionWarning" className="alert-warning">
            <FormattedMessage id="importExport.importMembers.form.warnings.noDivisions" />
          </MessageBox>
        );
      }
      if (isAutomaticMemberIdentifier) {
        warnings.push(
          <MessageBox key="isAutomaticMemberIdentifierWarning" className="alert-info">
            <FormattedMessage id="importExport.importMembers.form.warnings.automaticMemberIdentifier" />
          </MessageBox>
        );
      }
    }

    return warnings;
  }

  render() {
    const {
      invalid,
      noClasses,
      noCoverages,
      noDivisions,
      importing,
      noClientNumber,
      maximumRetroactiveDate,
      selectedClient,
      fetchingMaximumRetroactiveDate,
      fileFormat,
      sessions
    } = this.props;
    const disableSubmit =
      invalid || noClasses || noCoverages || noDivisions || importing || noClientNumber;
    const disableFields = importing || !!this.props.response.error || !!this.props.response.data;
    let billingPeriods = [];

    if (fetchingMaximumRetroactiveDate === false) {
      if (typeof maximumRetroactiveDate == "undefined" || maximumRetroactiveDate) {
        billingPeriods = this.props.billingPeriods.filter(billingPeriod => billingPeriod.startDate >= maximumRetroactiveDate);
      }
      else {
        billingPeriods = this.props.billingPeriods;
      }
    }

    return (
      <form
        onSubmit={this.props.handleSubmit}
        className="standalone-form import-export"
      >
        {this.renderResponse()}

        <Field
          id="clientId"
          name="clientId"
          component={SelectInput}
          searchable={true}
          disabled={disableFields}
          options={this.props.clients.map((client) => {
            return { value: client.clientId, text: client.name };
          })}
          addBlankOption={true}
          props={{ onChange: this.handleClientChange.bind(this) }}
          label={
            <FormattedMessage id="importExport.importMembers.form.client" />
          }
        />

        <Field
          id="billingPeriodId"
          name="billingPeriodId"
          component={SelectInput}
          sortOptions={false}
          disabled={fetchingMaximumRetroactiveDate === true || disableFields}
          options={billingPeriods.map((billingPeriod) => {
            return {
              value: billingPeriod.billingPeriodId,
              text: `${billingPeriod.localizations[this.props.authLanguageCode].name
                } (${this.context.intl.formatDate(billingPeriod.startDate, {
                  year: "numeric",
                  month: "numeric",
                  day: "numeric",
                  timeZone: "utc",
                })} ${this.context.intl.formatMessage({
                  id: "common.toDate",
                })} ${this.context.intl.formatDate(billingPeriod.endDate, {
                  year: "numeric",
                  month: "numeric",
                  day: "numeric",
                  timeZone: "utc",
                })})`,
            };
          })}
          addBlankOption={true}
          label={
            <FormattedMessage id="importExport.importMembers.form.billingPeriod" />
          }
        />
        {selectedClient && selectedClient.businessAccountType == PM.value && selectedClient.clientBillingPeriodType == MANUAL.value && (
          <Field
            id="classId"
            name="classId"
            component={SelectInput}
            sortOptions={false}
            disabled={disableFields}
            options={this.props.classes.map((eachClass) => {
              return {
                value: eachClass.classId,
                text: `${eachClass.name}`,
              };
            })}
            label={
              <FormattedMessage id="importExport.importMembers.form.class" />
            }
          />
        )}
        <Field
          id="fileFormat"
          name="fileFormat"
          component={SelectInput}
          disabled={disableFields}
          options={this.filterImportMemberFormats.bind(this)()}
          addBlankOption={true}
          label={
            <FormattedMessage id="importExport.importMembers.form.format" />
          }
        />

        {!!fileFormat && fileFormat != " " &&
          ![AETELUQ.value, AGECRO_CONTINUING_EDUCATION.value, AGECRO_ONLINE_EDUCATION.value, AGECRO_REGULAR_EDUCATION.value].includes(fileFormat) && (
            <Field
              id="file"
              name="file"
              component={FileInput}
              disabled={disableFields}
              label={
                <FormattedMessage id="importExport.importMembers.form.file" />
              }
              dropzoneLabel={
                <FormattedMessage id="importExport.importMembers.form.fileDesc" />
              }
            />
          )}

        {!!fileFormat && fileFormat != " " &&
          [AGECRO_REGULAR_EDUCATION.value].includes(fileFormat) && (
            <Field
              id="importSessionPeriod"
              name="importSessionPeriod"
              component={SelectInput}
              disabled={disableFields}
              options={sessions.map((session) => {
                return {
                  value: session.value,
                  text: session.key.split('.').reduce((acc, key) => acc && acc[key], this.translationFile)
                };
              })}
              label={
                <FormattedMessage id="importExport.importMembers.form.importSessionPeriod" />
              }
            />
          )}

        {this.renderWarnings()}

        <div className="import-export-submit">
          <span className="import-export-button">
            <button
              type="submit"
              className="btn btn-lg btn-primary"
              disabled={disableSubmit || disableFields}
            >
              <FormattedMessage id="importExport.actions.import" />
            </button>
          </span>

          {importing && (
            <span className="import-export-loader">
              <span className="loader">
                <FormattedMessage id="importExport.importing" />
              </span>
            </span>
          )}
        </div>
      </form>
    );
  }
}

ImportMembersForm.propTypes = {
  allLoaded: PropTypes.bool.isRequired,
  billingPeriods: PropTypes.array,
  billingPeriodId: PropTypes.number,
  changeFieldValue: PropTypes.func,
  resetErrorField: PropTypes.func,
  authLanguageCode: PropTypes.string,
  noClasses: PropTypes.bool.isRequired,
  noCoverages: PropTypes.bool.isRequired,
  noDivisions: PropTypes.bool.isRequired,
  clients: PropTypes.array,
  classes: PropTypes.array,
  fileFormat: PropTypes.string,
  handleClientChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func,
  importing: PropTypes.bool,
  invalid: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  response: PropTypes.object.isRequired,
  clientId: PropTypes.number,
  selectedClient: PropTypes.object,
  reset: PropTypes.func,
  clientInTransition: PropTypes.bool,
  noClientNumber: PropTypes.bool,
  refetchIsTransition: PropTypes.func,
  maximumRetroactiveDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  fetchingMaximumRetroactiveDate: PropTypes.bool,
  importSessionPeriod: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sessions: PropTypes.array
};

ImportMembersForm.contextTypes = {
  intl: intlShape,
};

const validate = (values, props) => {
  const client = props.clients.find(
    (item) => item.clientId.toString() === values.clientId
  );

  let validationRules = IMPORT_MEMBERS_VALIDATION_RULES;

  if (client && client.businessAccountType == PM.value && client.clientBillingPeriodType == MANUAL.value) {
    validationRules = {
      ...validationRules,
      classId: {
        isRequiredTrim: {
          value: true,
        },
      }
    };
  }

  if (values.file && values.clientId && values.clientId != " ") {
    let fileValidationRules = {
      ...validationRules.file,
      fileNameContainsSubString: {
        value:
          client.clientBillingPeriodType === "MANUAL"
            ? client.name
            : client.designator,
      },
    };
    if (
      values.fileFormat &&
      values.fileFormat != " " &&
      values.fileFormat == "FEUS"
    ) {
      fileValidationRules = {
        ...fileValidationRules,
        fileOfExtension: {
          value: [".txt"],
        },
      };
    } else {
      fileValidationRules = {
        ...fileValidationRules,
        fileOfExtension: {
          value: [".xls", ".xlsx"],
        },
      };
    }



    validationRules = {
      ...validationRules,
      file: fileValidationRules,
    };

    return validationUtils.validate(values, validationRules);
  }
  return validationUtils.validate(values, validationRules);
};

const selector = formValueSelector("importMembersForm");

function mapStateToProps(state, ownProps) {
  const clientId = Number.parseInt(selector(state, "clientId"));
  const clients = ownProps.clients;
  const billingPeriodId = Number.parseInt(selector(state, 'billingPeriodId'));

  const selectedClient = clients.find(
    (client) => client.clientId === clientId
  );

  return {
    clientId: clientId,
    billingPeriodId: billingPeriodId,
    selectedClient: selectedClient,
    noClientNumber: selectedClient && selectedClient.clientNumber ? selectedClient.clientNumber === null : true,
    fileFormat: selector(state, "fileFormat"),
    importSessionPeriod: selector(state, "importSessionPeriod"),
    authLanguageCode: state.auth.user.languageCode,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    resetErrorField: bindActionCreators(untouch, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: "importMembersForm",
    validate: validate,
  })(ImportMembersForm)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/importMembers/ImportMembersForm.js